/**
 * @file     panelLayout.ts
 * @purpose  Results-panel geometry shared by the live panel and the /properties
 *           loading fallback, so the server-rendered intro sits in the same
 *           place before and after the map chunk mounts.
 */

/** Phone: the map's share of the height at the default snap (panel below it).
 *  Low enough that the first card's photo shows under the header and the
 *  board notice at the middle snap. */
export const MOBILE_MAP_DEFAULT_PCT = 38;
/** Phone: the panel's grab strip above the header. */
export const MOBILE_PANEL_STRIP_HEIGHT = 28;
/** Desktop: the map's share of the width; the panel takes the rest. */
export const DESKTOP_MAP_WIDTH_PCT = 55;

/** Header insets in 4px spacing units (phone gutter 20, desktop 24). */
export const PANEL_HEADER_SX = {
  px: { xs: 5, sm: 6 },
  pt: { xs: 1, md: 5 },
  pb: 4,
  gap: 4,
} as const;
